

















































import { Component, Prop, Vue } from 'vue-property-decorator';
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';

@Component({
  components: {
    Header,
    Footer,
  },
})
export default class Landing extends Vue {
  public data() {
    return {
      beneficios: [
        { image: null, title: 'Sin salir de casa', description: 'Obtienes un tratamiento personalizado en la puerta de tu casa, y aunque todo es supervisado por ortodoncistas calificados, no tienes que preocuparte por ir a citas en un consultorio.', img: 'benefit-1' },
        { image: null, title: 'Practicidad', description: 'Los alineadores invisibles Toothly son más cómodos y convenientes que otros tratamientos de ortodoncia.', img: 'benefit-2' },
        { image: null, title: 'Costo accesible', description: 'Recibes un tratamiento de primera calidad pagando hasta 60% menos que con otras opciones.', img: 'benefit-3' },
      ],
      steps: [
        { image: null, number: 'Paso #1', title: 'Primera impresión', description: 'Te enviaremos directo a tu casa nuestro kit de impresiones Toothly para que puedas tomar muestras y que uno de nuestros ortodoncistas expertos genere el mejor plan de tratamiento para tus necesidades.', img: 'step-1' },
        { image: null, number: 'Paso #2', title: 'Cargando sonrisa', description: 'Paga y recibe tu set de alineadores invisibles Toothly y el kit de blanqueamiento y pon manos a la obra.', img: 'step-2' },
        { image: null, number: 'Paso #3', title: '¡No dejes de sonreír!', description: 'Una vez que hayas terminado tu tratamiento seguramente querrás mantener tu nueva sonrisa, para ello podrás adquirir de forma opcional tu set de retenedores invisibles Toothly.', img: 'step-3' },
      ],
    };
  }
}
